import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // baseUrl: "http://127.0.0.1:8002/ysxh",
        // frontUrl: "http://127.0.0.1:80",
        baseUrl: "https://www.tamda.org.cn:8089/ysxh",
        frontUrl: "https://www.tamda.org.cn",
        navsActive: 0,
        navIndex: 1,
        navs: [],
        token: "", 
        user: null,
        searchData: null,
        searchName: ""
    }, 
    mutations: {
        SET_SEARCH_NAME(state, val) {
            state.searchName = val;
        },
        SET_SEARCH_DATA(state, val) {
            state.searchData = val;
        },
        SET_NAVS_ACTIVE(state, val) {
            state.navsActive = val;
        },
        SET_NAV_INDEX(state, val) {
            state.navIndex = val;
        },
        SET_NAVS(state, val) {
            state.navs = val;
        },
        SET_TOKEN(state, val) {
            state.token = val;
        },
        SET_USER(state, val) {
            state.user = val;
        }
    },
    actions: {},
    modules: {}
});


// WEBPACK FOOTER //
// ./src/store/index.js